<template>
    <span :class="{ invisible: !visible }" class="d-lg-none">
        <a href="/notifications"
            class="d-inline-flex align-items-center btn btn-light position-relative d-md-none d-lg-none p-0 border-0 bg-transparent">
            <i class="bi bi-bell fs-3 d-lg-none"></i>
            <span class="badge badge-notification badge-primary bg-primary d-lg-none"
                style="top: 0; right: 0; transform: translate(-30%, -30%);">
                {{ state.display.value }}
            </span>
        </a>
    </span>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { userNotificationCounterState } from './useCounter';

export default defineComponent({
    name: 'NotificationsCounterMobile',
    components: {},
    setup() {

        const state = userNotificationCounterState();
        const visible = computed(() => state.counter.value > 0);

        return {
            visible,
            state
        };
    }
});
</script>

<style scoped>
.invisible {
    display: none;
}

.badge-notification {
    min-width: 36px;
    min-height: 22px;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    font-family: monospace;
}
</style>